var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 31.5H29.2499C31.7249 31.5 33.7499 29.475 33.7499 27V4.5H13.4999C10.1249 4.5 7.17746 6.36747 5.64746 9.11247",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 38.25C4.5 41.985 7.515 45 11.25 45H13.5C13.5 42.525 15.525 40.5 18 40.5C20.475 40.5 22.5 42.525 22.5 45H31.5C31.5 42.525 33.525 40.5 36 40.5C38.475 40.5 40.5 42.525 40.5 45H42.75C46.485 45 49.5 41.985 49.5 38.25V31.5H42.75C41.5125 31.5 40.5 30.4875 40.5 29.25V22.5C40.5 21.2625 41.5125 20.25 42.75 20.25H45.6525L41.805 13.5225C40.995 12.1275 39.5101 11.25 37.8901 11.25H33.75V27C33.75 29.475 31.725 31.5 29.25 31.5H27",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 49.5C20.4853 49.5 22.5 47.4853 22.5 45C22.5 42.5147 20.4853 40.5 18 40.5C15.5147 40.5 13.5 42.5147 13.5 45C13.5 47.4853 15.5147 49.5 18 49.5Z",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 49.5C38.4853 49.5 40.5 47.4853 40.5 45C40.5 42.5147 38.4853 40.5 36 40.5C33.5147 40.5 31.5 42.5147 31.5 45C31.5 47.4853 33.5147 49.5 36 49.5Z",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 27V31.5H42.75C41.5125 31.5 40.5 30.4875 40.5 29.25V22.5C40.5 21.2625 41.5125 20.25 42.75 20.25H45.6525L49.5 27Z",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 18H18",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 24.75H13.5",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 31.5H9",
    stroke: "#00CFC5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default __webpack_public_path__ + "static/media/transport.df56988ce28a8e015446eb9453240e19.svg";
export { ForwardRef as ReactComponent };